import styled from "styled-components";
import {
  headerSize,
  panelSpacing,
  Scrollable,
} from "../../../../../../common/styles";
import colors from "../../../../../../config/colors";

export const CloseButton = styled.span`
  position: absolute;
  cursor: pointer;
`;

export const ModalContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 10%;
  margin: 0 auto;
  width: ${({ width = "80%" }) => width};
  min-height: 300px;
  // max-height: 85vh;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 36.571px 365.714px 0px rgba(221, 218, 218, 0.25);
  z-index: 99;
  @media (max-width: 767px) {
    width: 96%;
    margin: 0 2%;
  }
`;

export const ModalCloseHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: #ededed;
  border-radius: 50%;
  border: 0;
  position: relative;
`;

export const ModalContent = styled.div`
  min-height: 300px;
  max-height: 70vh;
  ${Scrollable}
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #ededed;
  padding: 20px 25px 15px 25px;
  margin: 0 0 32px 0;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const Container = styled.div`
  width: 80vh;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ModalTitle = styled.span`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 700;
  @media (max-width: 767px) {
    font-size: 15px;
  }
`;

export const ModalFooter = styled.div`
  text-align: right;
  margin-top: 20px;
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 0 25px 0;
  span,
  a {
    display: inline-block;
    width: 100%;
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: 300;
    text-decoration: none;
  }
`;

export const ApplicationModalButton = styled.button`
  margin: 20px 10px;
  width: 110px;
  height: 40px;
  padding: 5px 16px;
  // margin:50px auto 30px auto;
  border-radius: 5px;
  border: 1px solid #ededed;
  ${"" /* background-color: transparent;   */}
  background: ${(props) =>
    props.variant === "submit" ? "#4F449B" : "transparent"};
  color: ${(props) => (props.variant === "submit" ? "white" : "")};
  cursor: pointer;
  &:hover {
    background: ${(props) => (props.variant === "close" ? "#bbb" : "#0056b3")};
  }
  @media (max-width: 767px) {
    margin: 0px;
    max-width: fit-content;
    padding: 4px 20px;
    margin-bottom: 12px;
  }
`;

export const ApplicationModalDate = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  align-self: flex-start;
  width: calc(100% - 65%);
  max-width: 160px;
  small,
  span {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: 400;
  }
  span {
    font-weight: 600;
  }
`;

export const ApplicationModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 25px 20px;
`;
export const ApplicationModalOuter = styled.div`
  ${Scrollable}
  min-height: 300px;
  max-height: 55vh;
`;
export const ApplicationModalLabel = styled.div`
  margin-bottom: 10px;
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 16px;
  font-weight: 300;
`;

export const ApplicationModalOption = styled.label`
  display: flex;
  align-items: center;
  gap: 20px;
  input {
    border-radius: 5px;
    border: 1px solid #d1d1d1;
    width: 24px;
    height: 24px;
  }
  span {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 16px;
    font-weight: 400;
  }
`;

export const ApplicationModalOptionGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 35px;
`;

export const ApplicationModalProfile = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

export const ApplicationModalProfileInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 60%;
  margin: 0 0 25px 0;
`;

export const ApplicationModalProfileThumb = styled.div`
  width: 50px;
`;

export const ApplicationModalProfileTitle = styled.div`
  margin-left: 15px;
  color: #302f2f;
  font-family: "Nunito Sans";
  h3 {
    font-size: 20px;
    font-weight: 500;
    margin: 0;
  }
  p {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
  }
`;

export const ApplicationModalSection = styled.div`
  margin: 0 25px 20px;
`;

export const ModalLoaderContainer = styled.div`
  background-color: ${colors.background};
  border-radius: ${panelSpacing}px;
  box-sizing: border-box;
  height: 60vh;
`;

export const ApplicationModalFooterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  padding: 0 20px;
  @media (max-width: 767px) {
    flex-wrap: nowrap;
  }
`;

export const Avatar = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50px;
  object-fit: cover;
`;

export const EmailContainer = styled.div`
  min-height: 250px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  margin: 0 25px 25px 25px;
  padding: 15px;
  box-sizing: border-box;
`;

export const EmailContainerHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const EmailContainerTitle = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 400;
`;

export const EmailContainerDownloadButton = styled.a`
  display: flex;
  width: 96px;
  padding: 5px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 5px;
  border: 1px solid #ededed;
  cursor: pointer;
  color: #333232;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 400;
  svg {
    width: 26px;
    height: 26px;
  }
`;

export const EmailBoxInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  gap: 55px;
  span {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media (max-width: 767px) {
      margin-top: 10px;
    }
  }
`;

export const PrdocutBoxGraph = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  @media (max-width: 767px) {
    flex-wrap: wrap;
    ul {
      margin-top: 15px;
    }
  }
  li {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-weight: 400;
    list-style-type: none;
    position: relative;
    padding-left: 15px;
    margin-bottom: 5px;
    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 9px;
      height: 9px;
      background-color: #4d4d9f;
      border-radius: 50%;
    }
  }
`;

export const EmailBox = styled.div`
  width: 100%;
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px 0 0 0;
    padding: 0;
    gap: 10px;
  }
  li {
    flex: 1 1 calc(50% - 10px);
    border-radius: 5px;
    background: #f4f4f4;
    padding: 10px;
    margin: 0 0 10px 0;
    box-sizing: border-box;
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-weight: 700;
    list-style-type: none;
  }
`;

export const LoaderOuter = styled.div`
  height: calc(100vh - 255px);
  @media (max-width: 1600px) {
    height: calc(100vh - 240px);
  }
`;

export const AggregateChartsContainer = styled.div`
  min-height: ${(props) => (props?.isFreeResponse ? "" : "250px")};
  height: fit-content;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 3.143px 31.429px 0px rgba(182, 174, 174, 0.25);
  margin: 0 25px 25px 25px;
  padding: 15px;
  box-sizing: border-box;
`;

export const AggregateChartsContainerHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const AggregateChartsTitle = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-weight: 400;
`;

export const AggregateChartsBoxInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  gap: 55px;
  span {
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    @media (max-width: 767px) {
      margin-top: 10px;
    }
  }
`;

export const AggregateChartsBox = styled.div`
  width: 100%;
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 10px 0 0 0;
    padding: 0;
    gap: 10px;
  }
  li {
    flex: 1 1 calc(50% - 10px);
    border-radius: 5px;
    background: #f4f4f4;
    padding: 10px;
    margin: 0 0 10px 0;
    box-sizing: border-box;
    color: #302f2f;
    font-family: "Nunito Sans";
    font-size: 14px;
    font-weight: 700;
    list-style-type: none;
  }
`;

export const BackButton = styled.button`
  border-radius: 5px;
  border: 1px solid #302f2f;
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: transparent;
  width: 100px;
  height: 40px;
`;

export const ButtonText = styled.h3`
  color: #302f2f;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;
